import { Link } from '@tanstack/react-router'
import type { PropsWithChildren } from 'react'
import { LanguageSwitcher } from '../../components/language/LanguageSwitcher'
import { PublicMobileNavigation } from '../../components/navigation/PublicMobileNavigation'
import { useI18n } from '../i18n/useI18n'
import './public-acquisition.css'
import '../../pages/LandingPage.mobile.css'

export function PublicSiteLayout({ children }: PropsWithChildren) {
  const { t } = useI18n()
  return <main className="marketing-page acquisition-page">
    <header className="marketing-nav acquisition-nav">
      <Link className="marketing-brand" to="/"><span className="brand-mark">PR</span><span>PropertyReady</span></Link>
      <div className="marketing-nav-actions">
        <nav aria-label={t('Primary navigation')}>
          <a href="/#how-it-works">{t('How it works')}</a>
          <Link to="/get-service">{t('Find services')}</Link>
          <Link to="/contractors">{t('For contractors')}</Link>
          <Link to="/property-managers">{t('For property managers')}</Link>
          <Link to="/sign-in">{t('Sign in')}</Link>
          <Link className="marketing-button public-founding-cta" to="/contractors" search={{ signup: true }}>{t('Join free')}</Link>
        </nav>
        <LanguageSwitcher className="public-language-switcher public-header-language" />
      </div>
      <PublicMobileNavigation />
    </header>
    {children}
    <footer className="marketing-footer">
      <Link className="marketing-brand" to="/"><span className="brand-mark">PR</span><span>PropertyReady</span></Link>
      <p>{t('Property work, organized in one place.')}</p>
      <nav><Link to="/get-service">{t('Find services')}</Link><Link to="/contractors">{t('For contractors')}</Link><Link to="/property-managers">{t('For property managers')}</Link><Link to="/privacy">{t('Privacy')}</Link><Link to="/terms">{t('Terms')}</Link></nav>
      <small>© {new Date().getFullYear()} PropertyReady. {t('All rights reserved.')}</small>
    </footer>
  </main>
}

export function CapabilityBadge({ state }: { state: 'AVAILABLE' | 'BETA' | 'COMING SOON' }) {
  const { t } = useI18n()
  return <span className={`capability-badge capability-${state.toLowerCase().replace(' ', '-')}`}>{t(state)}</span>
}
